<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="background-editor">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-images"></i>
                        <span v-if="for_portal">ポータル</span>
                        背景画像
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="nav nav-tabs mb-3">
                        <li class="nav-item">
                            <a href="#" class="nav-link" :class="{active: type == 'url'}" @click.prevent="changeType('url')">外部URL</a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" :class="{active: type == 'upload'}" @click.prevent="changeType('upload')">画像アップロード</a>
                        </li>
                        <li class="nav-item" v-if="pictures.length > 0">
                            <a href="#" class="nav-link" :class="{active: type == 'official'}" @click.prevent="changeType('official')">公式背景</a>
                        </li>
                    </ul>
                    <div class="mb-3" v-if="type == 'url'">
                        <label>画像の外部URL</label>
                        <div class="mb-3">
                            <input type="text" ref="url" v-model="background.url" class="form-control" placeholder="例）https://example.com/bg.jpg" @keydown.enter="save()">
                        </div>
                        <div class="small text-danger" v-if="book_id">
                            小説ページの背景に表示される画像です。
                            訪問者に表示されるので、利用規約に準じた画像のみを設定してください。
                        </div>
                        <div class="small text-muted" v-else-if="for_portal">
                            ご自身のみが表示する画像です。
                            ブラウザで表示できる画像であればどんなものでも構いません。
                        </div>
                        <div class="small text-danger" v-else>
                            本棚に表示される画像です。
                            訪問者に表示されるので、利用規約に準じた画像のみを設定してください。
                        </div>
                    </div>
                    <div class="mb-3" v-if="type == 'upload'">
                        <div class="small mb-3">
                            5MB以内の画像をアップロードできます。
                            アップロードされた画像は最適化され、ファイルサイズも小さくなります。
                        </div>
                        <div class="d-flex justify-content-center mb-3">
                            <div class="btn-group file-selector">
                                <label class="btn btn-secondary" style="margin: 0;" for="image">
                                    <i class="fas fa-file-image"></i>
                                    背景画像選択...
                                    <input type="file" id="image" ref="image" @change="fileSelected()" accept="image/*" class="d-none" />
                                </label>
                                <button type="button" @click="removeImage()" class="btn btn-light">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div v-if="$store.getters.user" class="mb-3">
                            <div>
                                現在使用中の画像ストレージ
                            </div>
                            <picture-storage :curr="curr" :max="$store.getters.user.storage_limit"></picture-storage>
                        </div>
                        <div class="d-flex justify-content-center mb-3" v-if="file.url">
                            <img :src="file.url" class="img-fluid preview" />
                        </div>
                    </div>
                    <div class="mb-3" v-if="type == 'official'">
                        <div class="mb-3" v-if="background.url">
                            <label>表示確認</label>
                            <img :src="background.url" class="img-fluid img-thumbnail">
                        </div>
                        <div class="mb-3" v-if="pictures.length > 0">
                            <label>公式背景</label>
                            <div class="small">
                                以下の公式画像から背景を選択することもできます。
                            </div>
                            <div class="d-flex justify-content-center flex-wrap">
                                <div class="img-column pointer"
                                    :class="{selected: p.id === background.picture_id}"
                                    @click="selectPicture(p.id)"
                                    v-for="p in pictures" :key="p.id">
                                    <img :src="p.thumb_url" class="cover">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button class="btn btn-outline-primary" @click="save()" :disabled="disableSave">
                        <span v-if="book_id">小説</span>
                        <span v-else-if="for_portal">ポータル</span>
                        <span v-else>本棚</span>
                        背景追加
                    </button>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<style scoped lang="scss">
.img-column {
    background-color: transparent;
    position: relative;
    height: 300px;
    border-radius: .5rem;
    margin: 10px;
    border: 5px solid transparent;
    overflow: hidden;
    .cover {
        object-fit: cover;
        width: 213px;
        height: 300px;
    }
    &.selected {
        border: 5px solid #ffa8a888;
    }
}
.preview {
    border-radius: .5rem;
}
</style>

<script>
import PictureStorage from "components/PictureStorage";
export default {
    components: {
        PictureStorage
    },
    props: {
        id: {
            default: "background-editor"
        },
        for_portal: {
            default: true
        },
        book_id: {
            default: null,
        }
    },
    data() {
        return {
            background: {},
            pictures: [],
            file: {
                info: null,
                url: null,
            },
            type: "url",
            curr: 0,
            isLoading: false,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/backgrounds/pictures", {params: { for_portal: this.for_portal ? 1 : 0}}).then(res => {
                this.pictures = res.data.pictures;
                this.curr = res.data.curr;
            }).catch(err => { alert.err(err.response) });
        },
        save() {
            this.isLoading = true;
            const fd = new FormData();
            if (this.file.info) {
                fd.append('info', this.file.info);
                fd.append('url', this.file.url);
            } else {
                if (this.background.url) {
                    fd.append('url', this.background.url);
                }
                if (this.background.picture_id) {
                    fd.append('picture_id', this.background.picture_id);
                }
            }
            if (this.for_portal) {
                fd.append('for_portal', this.for_portal);
            }
            if (this.book_id) {
                fd.append('book_id', this.book_id);
            }
            axios.post("/mypage/background/save", fd).then(res => {
                alert.msg("保存しました。");
                // ユーザー情報再読み込み
                if (!this.book_id) {
                    this.$store.state.backgroundCallback(true);
                }
                this.$emit("load");
                $("#" + this.id).modal("hide");
                this.isLoading = false;
            }).catch(err => {
                alert.err(err.response);
                this.isLoading = false;
            });
        },
        selectPicture(id) {
            if (this.background.picture_id !== id) {
                this.background.picture_id = id;
                this.background.url = "";
            } else {
                this.background.picture_id = null;
            }
        },
        fileSelected() {
            if (this.$refs.image.files[0].size > 5000 * 1024) {
                alert.err("ファイルサイズが大きすぎます: " + this.$filters.getByte(this.$refs.image.files[0].size));
                return;
            }
            this.file.info = this.$refs.image.files[0];
            this.file.url = URL.createObjectURL(this.file.info);
        },
        removeImage() {
            this.file.info = null;
            this.file.url = "";
        },
        changeType(type) {
            if (type !== this.type) {
                this.type = type;
                // すべてリセットする
                this.removeImage();
                this.background.picture_id = null;
                this.background.url = null;
            }
        }
    },
    watch: {
        'background.url'(n, o) {
            if (n) {
                this.background.picture_id = null;
            }
        }
    },
    computed: {
        disableSave() {
            if (this.isLoading) {
                return true;
            }
            if (this.background.url || this.background.picture_id || this.file.info) {
                return false;
            }
            return true;
        }
    },
    mounted() {
        $("#background-editor").on("show.bs.modal", (e) => {
            this.background = {};
            this.pictures = [];
            this.file = {
                info: null,
                url: null,
            };
            this.load();
        });
        $("#background-editor").on("shown.bs.modal", (e) => {
            if (this.$refs.url) {
                this.$refs.url.focus();
            }
        });
    }
}
</script>